import { useCallback, useEffect, useState } from "react";
import { getAbsoluteUrl } from "@danishagro/shared/src/components/organisms/SiteHeader/LanguageSelector/hooks/getAbsolutePath.hook";
import { DepartmentProps } from "../../../../../interfaces/department.interface";

export const useItems = (id?: string) => {
    const [items, setItems] = useState<DepartmentProps[]>([]);
    const [viewState, setViewState] = useState<string>("INIT");

    const fetchItems = useCallback(async () => {
        const cultureCode = globalThis?.cultures[0]?.alias;
        try {
            const url = getAbsoluteUrl("/getdepartments", "SPA", {
                rootNodeId: globalThis.rootNodeId,
                departmentIds: id,
            });
            const request = await fetch(`${url}&cultureCode=${cultureCode}`);

            if (request) {
                const response = await request.json();
                return response;
            }
        } catch {
            setItems(undefined);
            setViewState("ERROR");
        }
    }, [id]);

    const getItems = useCallback(async () => {
        try {
            const response = await fetchItems();

            if (response) {
                setItems(response);
                setViewState("DONE");
            } else {
                throw new Error();
            }
        } catch {
            setItems(undefined);
            setViewState("ERROR");
        }
    }, [fetchItems]);

    // Init

    useEffect(() => {
        getItems();
    }, [getItems]);

    return {
        items,
        viewState,
    };
};
